<template lang="html">
  <div class="aboutUs">
     <bannerTop :banners="$t('about.banners')"/>
     <div class="content">
        <label class="labelTitle storyTitle">{{titleToUpperCase($t('about.story.title'))}}</label>
       <div class="story">
         <div class="description" v-html="$t('about.story.description')"></div>
       </div>
       <div class="otherItem">
         <div class="item" v-for="(item,key) in $t('about.otherItem')" :key="key" :class="key ==0 || key == 2 || key == 4? 'write': ''" :style="{'background':'url('+item.imgUrl+')','backgroundSize':'cover'}">
           <label class="labelTitle" :class="key == 1 || key == 3? 'blue': ''">{{titleToUpperCase(item.title)}}</label>
           <p class="description" v-html="item.description"></p>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
import bannerTop from '@/components/bannerTop'
export default {
  name: 'aboutUs',
  data(){
    return {

    }
  },
  components:{
    bannerTop
  }
}
</script>

<style lang="less" src="../assets/css/about.less"></style>
